// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductCardName_container__XW6iR"};